// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__bxeQS","arrow":"styles_arrow__V6zHl","details":"styles_details__Yj_sa"};